import angular from 'angular';
import '@uirouter/angularjs';
import '@uirouter/angularjs/release/stateEvents';
import {vrmConfigModule} from './vrm-config';
import {vrmVueModule} from '@/angular-bridge/module';

export const vrmRouteModule = angular
    .module('vrm.route', [
        vrmConfigModule.name,
        vrmVueModule.name,
        'ui.router',
        'ui.router.state.events'
    ])
    .config(RoutesConfiguration)
    .config(Vue3RoutesConfiguration)
    .run(RouteInterceptor);

/* @ngInject */
function RoutesConfiguration(
    vrmConfig,
    $locationProvider,
    $urlRouterProvider
) {
    // Stop using hash in url
    $locationProvider.html5Mode({
        enabled: vrmConfig.locationHtml5Mode
    });

    // Redirects
    if (process.env.NODE_ENV === 'development') {
        $urlRouterProvider.when('/login', '/login-deprecated');
    } else {
        $urlRouterProvider.when('/login-deprecated', '/login');
    }
    $urlRouterProvider.when('/user/login', '/login');
    $urlRouterProvider.when('/user/logout', '/logout');
    $urlRouterProvider.when('/user/profile', '/profile/settings');
    $urlRouterProvider.when('/user/reset-password-request', '/forgot-password');
    $urlRouterProvider.when('/user/reset-twofactor-request', '/reset-twofactor-request');
    $urlRouterProvider.when('/user/register', '/register');
    $urlRouterProvider.when('/site', '/installation-overview');
    $urlRouterProvider.when('/user/register/invitekey/{key}', ['$match', function ($match) {
        return "/register/invite/" + $match.key;
    }]);
    $urlRouterProvider.when('/user/login/invitekey/{key}', ['$match', function ($match) {
        return "/login/invite/" + $match.key;
    }]);
    $urlRouterProvider.when('/user/login/evt/{key}', ['$match', function ($match) {
        return "/login/evt/" + $match.key;
    }]);
    $urlRouterProvider.when('/site/{id:int}/diagnostics', ['$match', function ($match) {
        return (typeof $match.id != "undefined" && $match.id) ? '/installation/' + $match.id + '/diagnostics' : false;
    }]);
    $urlRouterProvider.when('/site/share/{key}', ['$match', function ($match) {
        window.location.href = vrmConfig.api + "/auth/redirectshare?token=" + $match.key;
    }]);
    $urlRouterProvider.when('/site/share/token/{key}', ['$match', function ($match) {
        window.location.href = vrmConfig.api + "/auth/redirectshare?token=" + $match.key;
    }]);
    $urlRouterProvider.when('/site/share-login/{key}', ['$match', function ($match) {
        window.location.href = vrmConfig.api + "/auth/redirectshare?token=" + $match.key;
    }]);
    $urlRouterProvider.when('/installation/share/{key}', ['$match', function ($match) {
        window.location.href = vrmConfig.api + "/auth/redirectshare?token=" + $match.key;
    }]);
    $urlRouterProvider.when('/site/{id:int}?mainTabId&subTabId', ['$match', function ($match) {
        var redirectTo = "dashboard";
        if (typeof $match.subTabId != "undefined" && $match.subTabId && $match.mainTabId != "undefined" && $match.mainTabId) {
            if ($match.subTabId == "gateway" && $match.mainTabId == "settings")
                redirectTo = "settings/general";
            else if ($match.subTabId == "tags" && $match.mainTabId == "settings")
                redirectTo = "settings/tags";
            else if ($match.subTabId == "dynamic_ess" && $match.mainTabId == "settings")
                redirectTo = "settings/dynamic-ess";
            else if ($match.subTabId == "location" && $match.mainTabId == "settings")
                redirectTo = "settings/location";
            else if ($match.subTabId == "geofence" && $match.mainTabId == "settings")
                redirectTo = "settings/geofence";
            else if ($match.subTabId == "user-settings" && $match.mainTabId == "settings")
                redirectTo = "settings/users";
            else if ($match.subTabId == "alarms" && $match.mainTabId == "settings")
                redirectTo = "settings/alarms";
            else if ($match.subTabId == "system-overview" && $match.mainTabId == "settings")
                redirectTo = "overview";
        }
        else if ($match.mainTabId != "undefined" && $match.mainTabId) {
            if ($match.mainTabId == "advanced")
                redirectTo = "advanced";
        }
        return (typeof $match.id != "undefined" && $match.id) ? '/installation/' + $match.id + '/' + redirectTo : false;
    }]);
    $urlRouterProvider.when('/site/view/{id:int}', ['$match', function ($match) {
        return (typeof $match.id != "undefined" && $match.id) ? '/installation/' + $match.id + '/dashboard' : false;
    }]);
    $urlRouterProvider.when('/installation/{id:int}', ['$match', function ($match) {
        return (typeof $match.id != "undefined" && $match.id) ? '/installation/' + $match.id + '/dashboard' : false;
    }]);
    $urlRouterProvider.when('/installation/{id:int}/', ['$match', function ($match) {
        return (typeof $match.id != "undefined" && $match.id) ? '/installation/' + $match.id + '/dashboard' : false;
    }]);
    $urlRouterProvider.when('/site/diagnostics/{id:int}', ['$match', function ($match) {
        return (typeof $match.id != "undefined" && $match.id) ? '/installation/' + $match.id + '/diagnostics' : false;
    }]);


    // set default route
    $urlRouterProvider.otherwise(function($injector) {
        const path = window.location.pathname;

        // Check if the path contains a modal when being redirected from the vue3 project
        if (path.includes('/openModal=')) {
            return path.replace('/openModal=', '?openModal=');
        }

        const ApiService = $injector.get('ApiService');

        if (!ApiService.isLoggedIn()) {
            const loginTarget = process.env.NODE_ENV === 'development' ? '/login-deprecated' : '/login';
            window.location.href = loginTarget;
            return false;
        }

        const UserService = $injector.get('UserService');
        const siteCount = UserService.getSiteCountFromLocalStorage();
        const threshold = vrmConfig.fleetOwnerThreshold || 10;

        if (siteCount && siteCount >= threshold) {
            window.location.href = '/fleet-monitor';
            return false;
        }

        const InstallationsService = $injector.get('InstallationsService');

        const singleInstallationId = InstallationsService.getSingleInstallationId();
        if (singleInstallationId) {
            window.location.href = '/installation/' + singleInstallationId + "/dashboard" ;
            return false;
        }

        window.location.href = '/installation-overview';
        return false;
    });
}

// Paths that should do full page reload so vue3 project can be loaded.
// In case these paths don't align with the paths in vrm-front-vue3 devops/service.yaml,
// or nginx isn't configured properly, we only href once.
// If that href lands us in vrm-front again, then default back to the internal routing.
// We do this to prevent infinite hrefs.
const paths = [
    'base.installation.eventlogs',
    'base.installation.diagnostics',
    'base.fleet-monitor',
    'base.add-installations',
    'login',
    'register',
    'thank-you',
    'forgot-password',
    'reset-twofactor-request',
    'reset-twofactor',
]

/* @ngInject */
function Vue3RoutesConfiguration($stateProvider) {
    paths.forEach(path => {
        const parts = path.split('.');
        $stateProvider.state(path, {
            url: `/${parts[parts.length - 1]}`,
            data: {
                skipLoginCheck: true
            }
        });
    });
}

/* @ngInject */
function RouteInterceptor($transitions, $window) {
    $transitions.onBefore({}, function(trans) {
        const targetState = trans.to();
        const targetParams = trans.params();

        // Only trigger a reload if the user is navigating to one of the paths
        if (paths.includes(targetState.name)) {
            const pathParts = targetState.name.split('.');
            let targetUrl = `/${pathParts[pathParts.length - 1]}`;
            if (pathParts[1] === 'installation') {
                targetUrl = `/installation/${targetParams.id}/` + pathParts[2];
            }

            // Prevent infinite loop by ensuring we're not already on the target URL
            if ($window.location.pathname !== targetUrl) {
                // On local dev, add the /vite prefix to the target URL so we land in vrm-front-vue3
                if (process.env.NODE_ENV === 'development') {
                    targetUrl = '/vite' + targetUrl;
                }

                // Full page reload to targetUrl
                $window.location.href = targetUrl;
                return false; // Stops UI-Router from handling it
            } else {
                // Do nothing, i.e. use internal routing
            }
        }
    });
}

// Explicitly define dependencies to prevent minification issues
RouteInterceptor.$inject = ['$transitions', '$window'];
